import restGql from 'graphql-tag';

export const CreateSessionPackage = restGql`#graphql
    mutation CreateSessionPackage(
        $input: CreateSessionPackageMutationVariables!){
            createSessionPackage(input: $input) @rest(
                type: "CreateSessionPackageMutation",
                method: "POST",
                path: "/v2/sessions",
                bodyKey: "input"){
                    session {
                        id
                        title
                        sessionType
                        validFrom
                        validTo
                        flexibleHours
                        pricing{
                            ageGroupId
                            period
                            price
                            pricing
                            pricingGroupId
                        }
                        availability{
                            day
                            start
                            end
                        }
                        hiddenByUser
                    }
                }
        }`;
